"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
var shortcut_1 = require("./shortcut");
exports.Shortcut = shortcut_1.default;
var shortcuts_1 = require("./shortcuts");
exports.Shortcuts = shortcuts_1.default;
